export default __webpack_public_path__ + "static/media/eye.143614e1.svg";